import { create } from 'mobx-persist';
import CreditProductsStore from './creditProducts.store';
import ThemeStore from './theme.store';

class RootStore {
  theme: ThemeStore;
  creditProducts: CreditProductsStore;

  constructor() {
    this.theme = new ThemeStore();
    this.creditProducts = new CreditProductsStore();
  }
}

const hydrate = create({
  storage: localStorage,
});

const store = new RootStore();

hydrate('theme', store.theme);
hydrate('creditProducts', store.creditProducts);

export { ThemeStore, CreditProductsStore };
export default store;
